import { createRegistry } from '../extensions/createRegistry';
import type { WidgetRegistration } from './types';

/** Каталог виджетов. Модули и инстансы регистрируют компоненты в bootstrap. */
export const WidgetsRegistry = createRegistry<WidgetRegistration>('widgets');
